<template>
      <div class="hotels-pack-container-card bg-white my-5">
        <div class="md:flex items-center gap-5">
          <div class="img-container">
              <img class="md:w-56 h-40 w-full object-cover" :src="firstImageUrl" :alt="hotel.name + ' Image'" />
          </div>
          <div>
            <div class="flex items-end gap-5">
                <p class="mt-3 lg:mt-0 font-bold underline title-card">{{hotel.name}}</p>
                <div class="flex items-center space-x-1 my-2">
                  <span v-for="star in numberOfStars" :key="star">
                    <img src="/img/icons/star.svg" alt="Star Icon" class="w-4 h-4" />
                  </span>
                </div>
            </div>
            <div class="flex space-x-2 my-3 lg:my-4">
            <p>{{ hotel.description || $t('hotel_similar_text')}}</p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import HotelCategory from "../common/HotelCategory.vue";
import TripadvisorScore from "./TripadvisorScore.vue";
import { NIGHTS_SET_HOTEL } from "../../../store/nights/mutation-types";
import { goToStep } from "../mixins";
import { mapGetters } from "vuex";
import { NIGHTS_GET_NIGHTS } from "../../../store/nights/getter-types";

export default {
  mixins: [goToStep],
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    onlyInfo: {
      type: Boolean,
      required: true,
    },
    adults: {
      type: Number
    },
    nights: {
      type: Number
    },
    destination: {
      type: String
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  components: {
    HotelCategory,
    TripadvisorScore,
  },
  computed: {
    loading() {
      return (
        this.$store.state.nights.loading &&
        this.$store.state.nights.hotel.code === this.hotel.code
      );
    },
    rooms(){
      let arr = [];
      this.hotel.rooms.forEach(room => {
        arr.push(room);
      });
      return arr;
    },
     firstImageUrl() {
      if (this.hotel.images && this.hotel.images.length > 0) {
        return this.hotel.images[0].url;
      }
      return "/img/no-img-placeholder.jpg";
    },
    numberOfStars() {
      const category = this.hotel.category_name;
      const starsCount = parseInt(category.match(/\d+/)[0]);
      return Array(starsCount).fill();
    }
  },
  methods: {
    hotelCategoryMinWidth(categoryCode) {
      const stars = Number(categoryCode.replace(/(LUX)|(EST)/, ""));
      return `${stars * 25}px`;
    },
    select(hotel) {
      this.$store.commit(NIGHTS_SET_HOTEL, hotel);
      this.goToStep("extras");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.img-container {
    max-height: 170px;
    max-width: 210px;
    border-radius: 5px;
    img {
        border-radius: 5px;
    }
    @media screen and (max-width: 768px) {
      max-width: none;
      max-height: none;
      img {
        width:100%;
      }
    }
}
.title-card {
  font-size: 18px;
}
</style>
